class StickyProductBar extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.productForm = document.querySelector(`product-form[data-section-id="${this.dataset.section}"]`);
		if (!this.productForm) return;

		const observer = new IntersectionObserver(this.observerCallback.bind(this), {
			threshold: 0.1
		});
		observer.observe(this.productForm);
	}

	toggleStickyBar(isVisible) {
		this.classList.toggle('sticky_bar-hidden', isVisible);
	}

	observerCallback(entries) {
		const { isIntersecting } = entries[0];
		this.toggleStickyBar(isIntersecting);
	}
}

customElements.define('sticky-product-bar', StickyProductBar);